import { IServiceStatusResponse } from "@wingspanhq/payments/dist/interfaces";
import type { bankingApiSpec } from "@wingspanhq/wingspan-api-types";
import { selectorDefaultCurrency } from "../../../shared/selectors/selectorDefaultCurrency";

export const selectorDefaultInternalAccount = (
  internalAccounts: bankingApiSpec.InternalAccount[],
  paymentSettings?: IServiceStatusResponse
) => {
  const defaultCurrency = selectorDefaultCurrency(paymentSettings);

  const apPrefundingAccount = internalAccounts.find(
    internalAccount =>
      internalAccount.type === "ApPrefunding" &&
      internalAccount.currency === defaultCurrency &&
      internalAccount.status === "Active"
  );

  if (apPrefundingAccount) {
    return apPrefundingAccount;
  }

  const bankingAccount = internalAccounts.find(
    internalAccount =>
      internalAccount.type === "Banking" && internalAccount.status === "Active"
  );

  return bankingAccount;
};
